import React from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import IntlMessages from 'util/IntlMessages';
import { formatDateDefault } from 'services/DateFormatters';

class OrgSurveyCompareRow extends React.Component {
    state = {
        menuState: false,
        viewSurveyDetails: false,
        selectedSurveyDetails: '',
    };

    onOrgSurveyCompareSelected = (survey) => {
        const { onOrgSurveyCompareSelect } = this.props;
        onOrgSurveyCompareSelect(survey);
    };

    onOrgOptionToggle = () => {
        this.setState({ menuState: !this.state.menuState });
    };

    onDisplaySelectedSurveyDetails = () => {
        this.setState({ selectedSurveyDetails: 'farted' });
        this.setState({ viewSurveyDetails: true });
    };

    render() {
        const { orgSurveyCompare } = this.props;
        const { menuState, viewSurveyDetails, selectedSurveyDetails } = this.state;
        const { name, startDate, endDate } = orgSurveyCompare;
        const options = ['Details'];
        return (
            <div className="contact-item">
                <div className="form-control-checkbox d-flex">
                    <div className="form-checkbox">
                        <input
                            type="checkbox"
                            checked={orgSurveyCompare?.selected}
                            value="checked"
                            onClick={() => {
                                this.onOrgSurveyCompareSelected(orgSurveyCompare);
                            }}
                            onChange={() => {}}
                        />
                        <span className="check">
                            <i className="zmdi zmdi-check zmdi-hc-lg" />
                        </span>
                    </div>
                </div>
                <div className="col">
                    <p className="mb-0">
                        <span className="contact-name">{name}</span>
                        <span className="d-inline-block toolbar-separator">&nbsp;</span>
                        <span className="email d-inline-block mr-2">Start Date - {formatDateDefault(startDate)}</span>
                        <span className="d-inline-block toolbar-separator">&nbsp;</span>
                        <span className="phone d-inline-block">End Date - {formatDateDefault(endDate)}</span>
                    </p>
                </div>
                <div className="col-auto px-1 actions d-sm-flex">
                    <Dropdown isOpen={menuState} toggle={this.onOrgOptionToggle.bind(this)}>
                        <DropdownToggle tag="span">
                            <span className="icon-btn text-grey pointer">
                                <i className="zmdi zmdi-more-vert zmdi-hc-lg" />
                            </span>
                        </DropdownToggle>

                        <DropdownMenu>
                            {options.map((option) => (
                                <DropdownItem
                                    key={option}
                                    onClick={() => {
                                        if (option === 'Details') {
                                            this.onDisplaySelectedSurveyDetails(orgSurveyCompare);
                                        }
                                    }}
                                >
                                    {option}
                                </DropdownItem>
                            ))}
                        </DropdownMenu>
                    </Dropdown>
                </div>
                <SweetAlert
                    show={viewSurveyDetails}
                    custom
                    confirmBtnText={<IntlMessages id="button.close" />}
                    confirmBtnBsStyle="primary"
                    customIcon="assets/images/online-survey.jpeg"
                    title={`Survey name - ${orgSurveyCompare?.name ? orgSurveyCompare.name : 'survey name not defined'}`}
                    onConfirm={() => {
                        this.setState({ viewSurveyDetails: false });
                    }}
                >
                    {selectedSurveyDetails}
                </SweetAlert>
            </div>
        );
    }
}

export default OrgSurveyCompareRow;



// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/OrgSurveyCompareList/OrgSurveyCompareRow/index.js